<script setup lang="ts">
    import { longDate } from '@/formatters';
    import { useShippingStore } from '@/stores/shippingStore';

    const store = useShippingStore();
</script>

<template>
    <div
        v-if="store.showLog"
        class="mb-5">
        <div class="shipping-section-header block">
            Log
        </div>
        <b-table
            striped
            narrowed
            :default-sort="['dateCreated', 'desc']"
            paginated
            per-page="10"
            :data="store.selectedPackage!.log">
            <b-table-column
                v-slot="props"
                sortable
                field="dateCreated"
                label="Timestamp UTC">
                {{ longDate(props.row.dateCreated) }}
            </b-table-column>
            <b-table-column
                v-slot="props"
                field="logLevel"
                label="Log level">
                {{ props.row.logLevel }}
            </b-table-column>
            <b-table-column
                v-slot="props"
                field="message"
                label="Message">
                {{ props.row.message }}
            </b-table-column>
        </b-table>
    </div>
</template>
